<div class="experts-container">
    <!-- Header Section -->
    <div class="header-section">
        <div class="breadcrumb">Expertos > <span style="color: red;">Bienestar y salud</span></div>
        <h1 class="main-title">ENCUENTRA A TU EXPERTO</h1>
        <p class="subtitle">Próximamente encontraras expertos en la dimensión de tu interés para acelera tu camino.</p>
    </div>

    <!-- Filter Bar -->
    <div class="filter-bar">
        <button class="filter-btn" *ngFor="let categoria of categorias" 
                (click)="selectCategory(categoria)"
                [class.active]="selectedCategoryId === categoria.id">
            {{ categoria.name }} ({{ getCategoryCount(categoria.id) }})
        </button>
    </div>

    <!-- Expert Cards Grid -->
    <div class="experts-grid">
        <div class="loader" *ngIf="isLoading">Cargando...</div>

        <!-- No results message -->
        <div *ngIf="!isLoading && expertosCount === 0" class="no-results">
            <!-- No se encontraron expertos que coincidan con tu búsqueda. -->
            <!--h5 class="no-mentors-title">ENCUENTRA A TU EXPERTO</h5>
            <p class="no-mentors-subtitle">Encuentra expertos en la dimensión de interés y acelera tu camino.</p-->
            <div class="no-mentors-container">
                <div class="no-mentors-message">
                  <h2>¡Estamos preparando algo especial para ti!</h2>
                  <p>Pronto podrás acceder al directorio de expertos Phoenix y conectar con quienes te ayudarán a alcanzar tus metas.</p>
                </div>
            </div>
        </div>

        <!-- Expert cards -->
        <div *ngIf="!isLoading && expertosCount > 0" class="expert-cards">
            <ng-container *ngFor="let mentor of displayedMentors">
                <div class="expert-card" *ngIf="mentor.name.trim() !== 'Team Phoenix'.trim() || mentor.name.trim() !== 'Jaime Aguirre Guarderas'.trim()">
                    <div class="card-header">
                        <img [src]="getProfilePhotoUrl(mentor)" alt="Foto de perfil" class="expert-photo" />
                        <div class="expert-info">
                            <h3 class="expert-name">{{ mentor.name }}</h3>
                            <p class="expert-profession">{{ mentor.coachProfileData?.professionalTitle || '-' }}</p>
                        </div>
                    </div>
                    
                    <div class="card-tags">
                        <!-- Mostrar solo la primera categoría y un tag con el contador de adicionales -->
                        <div class="category-tags-container" *ngIf="mentor.categoryExperts && mentor.categoryExperts.length > 0">
                            <span class="category-tag">{{ mentor.categoryExperts[0] }}</span>
                            <span class="category-tag" 
                                  *ngIf="mentor.categoryExperts.length > 1"
                                  [title]="getRemainingCategories(mentor.categoryExperts)">
                                + {{ mentor.categoryExperts.length - 1 }}
                            </span>
                        </div>
                        <div class="category-tags-container" *ngIf="!mentor.categoryExperts || mentor.categoryExperts.length === 0">
                            <span class="category-tag">{{ mentor.categoryExpert || '-' }}</span>
                        </div>
                        <div class="duration-price-row">
                            <span class="duration-tag">60 min</span>
                            <span class="price-tag">{{ formatExpertPrice(mentor.expertCost) }}</span>
                        </div>
                    </div>
                    
                    <div class="card-description">
                        <p>{{ limitTextToWords(mentor.coachProfileData?.aboutMentor) }}</p>
                    </div>
                    
                    <div class="card-actions">
                        <!-- <span class="ver-mas">Ver más ></span> -->
                        <div class="action-buttons">
                            <button class="btn-ver-perfil" (click)="goToMentorProfile(mentor.id)">Ver perfil</button>
                            <button class="btn-agendar" (click)="scheduleAppointment(mentor.id)">Agendar</button>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>

    <!-- Pagination -->
    <div class="pagination-section" *ngIf="!isLoading && expertosCount > 0">
        <div class="pagination-controls">
            <button class="pagination-btn" [disabled]="currentPage === 1" (click)="previousPage()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="15,18 9,12 15,6"></polyline>
                </svg>
            </button>
            
            <div class="page-numbers">
                <!-- Mostrar páginas dinámicamente -->
                <ng-container *ngFor="let page of getVisiblePages()">
                    <button class="page-btn" 
                            [class.active]="currentPage === page" 
                            (click)="goToPage(page)">{{ page }}</button>
                </ng-container>
                
                <!-- Puntos suspensivos y última página si es necesario -->
                <ng-container *ngIf="totalPages > 5 && currentPage < totalPages - 2">
                    <span class="page-dots">...</span>
                    <button class="page-btn" 
                            [class.active]="currentPage === totalPages" 
                            (click)="goToPage(totalPages)">{{ totalPages }}</button>
                </ng-container>
            </div>
            
            <button class="pagination-btn" [disabled]="currentPage === totalPages" (click)="nextPage()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="9,18 15,12 9,6"></polyline>
                </svg>
            </button>
        </div>
        
        <div class="pagination-info">
            <span class="results-info">Mostrando {{ getDisplayedItemsText() }} de {{ expertosCount }} resultados</span>
            <div class="items-per-page">
                <span>Mostrar</span>
                <select [(ngModel)]="itemsPerPage" (change)="onItemsPerPageChange()">
                    <option value="6">6</option>
                    <option value="12">12</option>
                    <option value="24">24</option>
                </select>
            </div>
        </div>
    </div>
</div>